@if (operatingInfo) {
  <ion-grid [ngClass]="isMultiTenant ? 'sis-multitenant-grid' : 'sis-grid'">
    <ion-row>
      <ion-col>
        <img [src]="logoUrl" class="sis-tenant-logo" />
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center" data-test="sis-operating-info-title">
        <h3>{{ 'operatinginfo.title' | translate }}</h3>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        @for (item of operatingInfo.entries; track item) {
          <sis-operating-info-item
            class="sis-operating-info-item"
            [entry]="item"
            data-test="sis-operating-info-item"
          ></sis-operating-info-item>
        }
      </ion-col>
    </ion-row>
    @for (link of operatingInfo.links; track link) {
      <ion-row
        class="sis-link-row vertical-align-content"
        data-test="sis-operating-info-links"
        >
        <ion-col>
          <a href="{{ link.url }}" target="_blank">
            <ion-icon [name]="link.iconName"></ion-icon>
          </a>
          <a href="{{ link.url }}" target="_blank">
            <span>{{ link.description}}</span>
          </a>
        </ion-col>
      </ion-row>
    }
  </ion-grid>
}

@if (operatingInfo && !isMultiTenant) {
  <ion-grid class="sis-footer-grid" data-test="sis-operating-info-tenant-footer">
    <ion-row>
      <ion-col>
        <span>{{ 'operatinginfo.information' | translate }}</span><br />
        <a href="{{ websiteUrl }}" target="_blank">{{ websiteDisplayUrl }}</a><br />
        <a href="tel:{{ operatingInfo.tenants[0].phone }}">Tel. {{ operatingInfo.tenants[0].phone }}</a>
      </ion-col>
    </ion-row>
  </ion-grid>
}

@if (operatingInfo && isMultiTenant) {
  <ion-grid class="sis-tab-grid" data-test="sis-operating-info-tenant-tab">
    <ion-row>
      @for (tenant of operatingInfo.tenants; track trackByGuid($index, tenant)) {
        <ion-col>
          <a href="{{ tenant.website }}" target="_blank">
            <ion-img
              [src]="publicAssetLogoBaseUrl + tenant.logo"
              class="sis-tab-logo"
              data-test="sis-operating-info-tenant-logo"
            ></ion-img>
          </a>
          <a href="{{ tenant.website }}" target="_blank">
            <span class="sis-tab-span">{{ tenant.alias }}</span>
          </a>
        </ion-col>
      }
    </ion-row>
  </ion-grid>
}
